module.exports = __webpack_public_path__ + "static/media/mEnzi.a093fbd5.jpeg";